const mixin = {
    data: ()=>{
        let user = {
            roles: []
        };
        if(window.mpsUser){
            user = window.mpsUser
        }

        return {
            user: user
        }
    },
    methods:{
        isClient(){
            return this.user.roles.indexOf('mps_client') != -1;
        },
        isRental(){
            return this.user.roles.indexOf('mps_rental') != -1;
        },
        isRentalCheckUser(){
            return this.user.roles.indexOf('at_rental_check') != -1;
        },
        isRentalCheckCapability(){
            return this.isAdministrator() || this.isRentalCheckUser() || this.isSixtAdmin();
        },
        isRentalCapability(){
            return this.user.roles.indexOf('administrator') != -1 || this.user.roles.indexOf('mps_rental') != -1 || this.isSixtAdmin();
        },
        isSurveyor(){
            return this.user.roles.indexOf('mps_surveyor') != -1
        },
        isSurveyorCapability(){
            return this.user.roles.indexOf('administrator') != -1 || this.user.roles.indexOf('mps_surveyor') != -1 || this.isSixtAdmin() || this.isCirclek()
        },
        isEuropcarAdmin(){
            return this.user.roles.indexOf('europcar_admin') != -1;
        },
        isSixtAdmin(){
            return this.user.roles.indexOf('sixt_admin') != -1;
        },
        isEuropcarUser(){
            return this.user.roles.indexOf('europcar_user') != -1;
        },
        isEuropcar(){
            return this.isEuropcarAdmin() || this.isEuropcarUser();
        },
        isCirclek(){
            return this.user.roles.indexOf('circlek_admin') != -1;
        },
        isEuropcarCapability(){
            return this.user.roles.indexOf('administrator') != -1 || this.isEuropcar();
        },
        isEuropcarDenmark(){
            return this.user.roles.indexOf('europcar_denmark') != -1 && this.isEuropcar();
        },
        isAldAdmin(){
            return this.user.roles.indexOf('ald_admin') != -1;
        },
        isAldUser(){
            return this.user.roles.indexOf('ald_user') != -1;
        },
        isAld(){
            return this.isAldAdmin() || this.isAldUser();
        },
        isAldCapability(){
            return this.user.roles.indexOf('administrator') != -1 || this.isAld();
        },
        isAdministrator(){
            return this.user.roles.indexOf('administrator') != -1;
        },
        isGuest(){
            return !this.user.roles.length;
        },
        isUser(){
            return this.user.roles.length;
        },
        checkAccess( route ){
            if( route.name == 'reports-code' )
                return true;
            if( this.isGuest() ){
                window.location.href = "/wp-login.php?redirect_to=" + encodeURIComponent(window.location.href);
                return false;
            }
        },
        isUserCanEdit(report){
            if( this.isGuest() )
                return false;
            if( this.isAdministrator() )
                return true;
            if( this.isSixtAdmin() )
                return true;
            if( this.isCirclek() )
                return true;
            if( this.isSurveyorCapability() )
                return (!report.id || this.user.ID == report.id_user) && !report.id_parent_report;
            if( this.isClient() )
                return report.id_parent_report && this.user.ID == report.id_client;
            if( this.isRentalCapability() )
                return report.id_report_type == 2 && (!report.id || this.user.ID == report.id_user);
            if( this.isEuropcarCapability() )
                return report.id_report_type == 4;
            if( this.isRentalCheckCapability() )
                return report.id_report_type == 5;
            if( this.isAldCapability() )
                return report.id_report_type == 6;
            return false;
        }
    },
    created(){
        this.$router.beforeEach((to, from, next) => {
            this.checkAccess(to)
            next();
        })
        this.checkAccess(this.$route)
    }
}
export default mixin


// WEBPACK FOOTER //
// ./reports/assets/src/mixins/user.js